<template>
	<Modal
		v-if="showRemoveUserModal"
		:allow-close="false"
		@modal:close="shareResumeStore.hideRemoveUserModal"
	>
		<template #body>
			<div class="won-delete-red text-2xl font-semibold">Remove access for {{ userToBeRemoved.email }}</div>
			<div class="won-blue mt-2.5 text-sm">Are you sure that you want to remove access for selected user?</div>

			<div class="mt-4 flex items-center gap-4">
				<button
					class="h-9 w-full rounded border border-won-green font-[Inter] text-sm font-medium text-won-green"
					@click="handleClose"
				>
					Cancel
				</button>

				<button
					class="h-9 w-full rounded bg-won-green font-[Inter] text-sm font-medium text-white hover:opacity-90"
					@click="handleDelete"
				>
					Delete
				</button>
			</div>
		</template>
	</Modal>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useResumeShare } from '../store/share-resume.store';

import Modal from '../components/modal.vue';

const shareResumeStore = useResumeShare();

const { showRemoveUserModal, userToBeRemoved } = storeToRefs(shareResumeStore);

const handleClose = () => {
	shareResumeStore.hideRemoveUserModal();
};

const handleDelete = () => {
	shareResumeStore.removeUserFromShareList();
};
</script>
